// Module
var code = `<fragment-loader src="{{ \$ctrl.frameUrl }}" frame-name="blip-desk" class="h-100 w-100" on-load="\$ctrl.onFrontendLoad()" on-error="\$ctrl.onFrontendError()" error-message="{{ \$ctrl.errorMessage }}"></fragment-loader> `;
// Exports
module.exports = code;